const UrlName = '/modular/admin/v1'
import URL from '../../config/url';
export default API => ({
    getConfiguration() {
      let url = URL.confUrl;
        return API({ 
          url: `${UrlName}/configurations/${url}`,
        });
    },
    getPageJson(){
      const params = {};
      params.domain = URL.confUrl;
      return API({ 
        url: `${UrlName}/block/getPageConfig`, 
        params: params,
        method: 'POST',
      });
    },
})
 